import React, { Component } from 'react';
import CancelUrl, { COMPONENT_STYLE } from '../CancelUrl/CancelUrl';
import FooterLinks from './FooterLinks';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import './Footer.less';
import { FLOW_TYPE } from '../../../framework/App/AppConstants';
import { isXOFlow } from '../../../framework/App/AppUtils';

export class Footer extends Component {
    static propTypes = {
        errorType: PropTypes.string,
        onCancel: PropTypes.func,
        pageName: PropTypes.string,
        flow: PropTypes.oneOf(Object.values(FLOW_TYPE)),
        cancelUrlProvided: PropTypes.bool,

        // Passed in props
        showCancelUrl: PropTypes.bool
    };

    static defaultProps = {
        showCancelUrl: true,
        cancelUrlProvided: true
    };

    shouldShowCancelUrl = () => {
        const { errorType, showCancelUrl, flow, cancelUrlProvided } = this.props;
        const isInvalidFlow = errorType === 'invalidFlow';

        return (showCancelUrl && !isInvalidFlow && isXOFlow(flow) && cancelUrlProvided);
    };

    render() {
        const { pageName } = this.props;
        return (
            <footer className="Footer">
                <div id="cue-footer">
                    {this.shouldShowCancelUrl() && (
                        <CancelUrl
                            componentType={COMPONENT_STYLE.FOOTER_LINK}
                            fptiEvent={{
                                stateName: `apply_pp_credit_${pageName}`,
                                transitionName: `cancel_and_return_apply_pp_credit_${pageName}`
                            }}
                        />
                    )}
                    <FooterLinks />
                </div>
            </footer>
        );
    }
}

export const mapStateToProps = state => ({
    errorType: _.get(state, 'serverData.errorType'),
    pageName: _.get(state, 'skeletonPage.currentPage'),
    flow: _.get(state, 'serverData.flow'),
    cancelUrlProvided: _.get(state, 'serverData.cancelUrlProvided')
});

export default connect(mapStateToProps)(Footer);
